/**
 * Gerador de Senhas Seguras
 * Gera senhas que atendem todos os requisitos de segurança
 */

/**
 * Gera uma senha segura aleatória
 * @param {number} length - Comprimento da senha (mínimo 8)
 * @returns {string} Senha gerada
 */
export const generateSecurePassword = (length = 12) => {
  // Garantir comprimento mínimo
  const finalLength = Math.max(8, length);
  
  // Conjuntos de caracteres
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const special = '@$!%*?&';
  
  // Garantir pelo menos 1 de cada tipo (requisitos obrigatórios)
  let password = '';
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += special[Math.floor(Math.random() * special.length)];
  
  // Preencher o resto com caracteres aleatórios de todos os conjuntos
  const allChars = lowercase + uppercase + numbers + special;
  for (let i = password.length; i < finalLength; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }
  
  // Embaralhar a senha para não ter padrão previsível
  return password.split('').sort(() => Math.random() - 0.5).join('');
};

/**
 * Gera uma senha memorável (palavras + números + especial)
 * @returns {string} Senha memorável
 */
export const generateMemorablePassword = () => {
  const words = [
    'Sol', 'Lua', 'Mar', 'Rio', 'Ceu', 'Paz', 'Luz', 'Flor',
    'Casa', 'Vida', 'Amor', 'Fogo', 'Agua', 'Terra', 'Vento'
  ];
  
  const word1 = words[Math.floor(Math.random() * words.length)];
  const word2 = words[Math.floor(Math.random() * words.length)];
  const number = Math.floor(Math.random() * 100);
  const special = '@$!%*?&'[Math.floor(Math.random() * 7)];
  
  return `${word1}${word2}${number}${special}`;
};

/**
 * Copia texto para a área de transferência
 * @param {string} text - Texto para copiar
 * @returns {Promise<boolean>} True se copiado com sucesso
 */
export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback para navegadores antigos
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textArea);
      return success;
    }
  } catch (error) {
    console.error('Erro ao copiar para área de transferência:', error);
    return false;
  }
};
